export default __webpack_public_path__ + "static/media/PPI-patio-017.7eebf404.jpg";